export const normalizeKey = (v: unknown): string =>
    (v ?? '').toString().trim().toLowerCase();

export const getInitials = (name?: string, max = 2) => {
  const safe = (name ?? '').trim().replace(/\s+/g, ' ');
  if (!safe) return 'U';
  const parts = safe.split(' ');
  return parts.slice(0, Math.min(parts.length, max))
              .map(p => p[0]!.toUpperCase())
              .join('');
};